import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupContentDirective } from './popup-content.directive';

@NgModule({
  declarations: [
    PopupContentDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PopupContentDirective
  ]
})
export class PopupContentModule { }
